import type { JournalEntry } from "../../entities/ledger/types";
import { apiRequest } from "../../shared/api/client";

export interface TransactionPage {
  transactions: JournalEntry[];
  nextCursor: string;
}

// The journal of a whole book over a period, newest first. The server pages
// with an opaque cursor, so a long month is read in chunks.
// categoryID is empty for every category, a category id, or "none" for the
// transactions that carry none. The server filters, so a count is a count of
// the whole period rather than of whatever page happens to be loaded.
export function listTransactions(bookID: string, from: string, to: string, cursor = "", categoryID = "", limit = 100): Promise<TransactionPage> {
  const query = new URLSearchParams({ from, to, limit: String(limit) });
  if (cursor) query.set("cursor", cursor);
  if (categoryID) query.set("categoryId", categoryID);
  return apiRequest(`/v1/books/${encodeURIComponent(bookID)}/transactions?${query}`);
}

export function getTransaction(transactionID: string): Promise<JournalEntry> {
  return apiRequest(`/v1/transactions/${encodeURIComponent(transactionID)}`);
}
